import { render, staticRenderFns } from "./ServiceRequestAwaitingApproval.vue?vue&type=template&id=8851de38&"
import script from "./ServiceRequestAwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestAwaitingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports